import "./MyAccount.module.css";
import Header from "@/reusable_sections/Header";
import WooCommerceMyAccount from "./sections/WooCommerceMyAccount";
import Footer from "@/reusable_sections/Footer";
export default function MyAccountPage() {
  return <div>
      <Header />
      <WooCommerceMyAccount />
      <Footer />
    </div>;
}